import type {
	CurrencySetting,
	SystemSetting,
	UpdateCurrencySettingRequest,
	UpdateSystemSettingRequest,
} from "src/types";
import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

const settingsProvider = {
	async listSystemSettings(): Promise<SystemSetting[]> {
		const response = await apiRequest.get(withApiPath("/settings/system"));
		return response.data;
	},

	async getSystemSetting(key: string): Promise<SystemSetting> {
		const response = await apiRequest.get(
			withApiPath(`/settings/system/${encodeURIComponent(key)}`),
		);
		return response.data;
	},

	async updateSystemSetting(
		key: string,
		data: UpdateSystemSettingRequest,
	): Promise<SystemSetting> {
		const response = await apiRequest.put(
			withApiPath(`/settings/system/${encodeURIComponent(key)}`),
			data,
		);
		return response.data;
	},

	async getSystemSettingHistory(key: string): Promise<SystemSetting[]> {
		const response = await apiRequest.get(
			withApiPath(`/settings/system/${encodeURIComponent(key)}/history`),
		);
		return response.data;
	},

	async listCurrencySettings(enabledOnly = false): Promise<CurrencySetting[]> {
		const response = await apiRequest.get(withApiPath("/settings/currency"), {
			params: { enabled_only: enabledOnly },
		});
		return response.data;
	},

	async getCurrencySetting(ticker: string): Promise<CurrencySetting> {
		const response = await apiRequest.get(
			withApiPath(`/settings/currency/${encodeURIComponent(ticker)}`),
		);
		return response.data;
	},

	async updateCurrencySetting(
		ticker: string,
		data: UpdateCurrencySettingRequest,
	): Promise<CurrencySetting> {
		const response = await apiRequest.put(
			withApiPath(`/settings/currency/${encodeURIComponent(ticker)}`),
			data,
		);
		return response.data;
	},
};

export default settingsProvider;
